module.exports = __webpack_public_path__ + "assets/img/qrcode-wechat.68bc8fff.png";